// extracted by mini-css-extract-plugin
export default {"listItem":"TermsConditions_listItem__x2SEV"};